export class Paxes {
  type: string;
  name: string;
  surname: string;
}
